const STEPS = [
  {
    number: "01",
    title: "Build",
    description:
      "Design your agent graph in the visual builder. Configure skills, tools, and sub-agent routing topology. Define which LLM provider each agent uses.",
    bullets: [
      "Visual agent graph editor",
      "Skill and tool assignment",
      "Multi-LLM provider routing",
    ],
    href: "/docs/flows/graph",
    linkLabel: "Designing the agent routing graph",
  },
  {
    number: "02",
    title: "Connect",
    description:
      "Wire up MCP servers, HTTP tools, or your own APIs. Set context requirements and approval gates. Encrypted credential storage for every provider.",
    bullets: ["MCP server integration", "HTTP tool definitions", "Approval gates per tool"],
    href: "/docs/flows/mcp-servers",
    linkLabel: "Connecting MCP servers and tools",
  },
  {
    number: "03",
    title: "Deploy",
    description:
      "Generate a project API key and stream agent responses from a single endpoint. Replay any execution. Observe every run in the timeline.",
    bullets: ["Project-scoped API keys", "SSE streaming endpoint", "Execution replay & tracing"],
    href: "/docs/flows/call-api",
    linkLabel: "Calling your agent from the API",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20">
      <div className="mb-12">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-primary-text">
          How it works
        </p>
        <h2 className="max-w-2xl text-3xl font-extrabold tracking-tight text-text sm:text-4xl">
          From idea to production
          <br />
          in three steps.
        </h2>
      </div>

      <div className="relative grid gap-8 lg:grid-cols-3">
        {/* Connector line — desktop only */}
        <div
          aria-hidden
          className="pointer-events-none absolute left-[calc(33.33%-1px)] top-9 hidden h-px w-[calc(33.34%+2px)] border-t border-dashed border-border lg:block"
          style={{ left: "calc(33.33% - 1px)" }}
        />
        <div
          aria-hidden
          className="pointer-events-none absolute top-9 hidden h-px border-t border-dashed border-border lg:block"
          style={{ left: "calc(66.66% - 1px)", width: "calc(33.34% + 2px)" }}
        />

        {STEPS.map((step, i) => (
          <div key={step.number} className="relative">
            {/* Step number circle */}
            <div className="mb-5 flex items-center gap-3">
              <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-primary bg-primary-dim">
                <span className="font-mono text-xs font-bold text-primary-text">{i + 1}</span>
              </div>
              <div className="h-px flex-1 border-t border-dashed border-border lg:hidden" />
            </div>

            <h3 className="mb-2 text-xl font-extrabold text-text">{step.title}</h3>
            <p className="mb-4 text-sm leading-relaxed text-text-muted">{step.description}</p>
            <ul className="space-y-1.5">
              {step.bullets.map((bullet) => (
                <li key={bullet} className="flex items-center gap-2 text-xs text-text-faint">
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                  {bullet}
                </li>
              ))}
            </ul>
            <a
              href={step.href}
              className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-text underline-offset-4 hover:underline"
            >
              {step.linkLabel}
              <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
